<template>
  <div
    class="text-gray-400 hover:text-bc-blue flex-grow text-center cursor-pointer"
    @click.stop.prevent="click()"
  >
    <aw-icon
      icon="text"
      class="cursor-pointer w-6 h-6  "
    ></aw-icon>
    <div class="pt-2 leading-none">{{ $t('Text') }}</div>
  </div>
</template>

<script>
import BaseAddElement from '../../../mixins/BaseAddElement'
export default {
  mixins: [BaseAddElement],
  methods: {
    click() {
      this.addChild('text', {
        html: '<p>' + this.$t('Enter description here...') + '</p>'
      })

      this.$emit('onselect')
    }
  }
}
</script>
